export const REDIRECT_DOMAINS = {
  RETAIL: "https://www.boingo.com/for-travel",
  MILITARY: "https://www.boingo.com/for-military",
  PS: "https://www.boingo.com",
} as const;

export const SUBDOMAIN_PREFIXES = {
  RETAIL: "retail",
  MILITARY: "military",
  PS: "ps",
} as const;
